import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'fgb-auction-wallet-details-page',
  templateUrl: './auction-wallet-details-page.component.html',
  styleUrls: ['./auction-wallet-details-page.component.scss'],
})
export class AuctionWalletDetailsPageComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private rewardsWalletService: RewardsWalletService,
    private location: Location
  ) {}
  id: number;

  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }

  goBack() {
    this.location.back();
  }
}
